import { Component, contentChildren, input } from '@angular/core';
import { SimpleTableColumnDef } from './simple-table-column-def';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'fb-simple-table',
  imports: [NgTemplateOutlet],
  templateUrl: './simple-table.html',
  styleUrl: './simple-table.scss',
})
export class SimpleTable<Item extends object> {
  /**
   * The data to be displayed in the table.
   */
  public readonly data = input<readonly Item[]>([]);

  /**
   * The columns to be displayed in the table.
   */
  public readonly columns = contentChildren(SimpleTableColumnDef);
}
